import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { homedir } from 'os';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { LoginComponent } from './components/login/login.component';
import { HomeModule } from './home/home.module';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { AuthGuard } from './shared/services/auth-guard.guard';

const routes: Routes = [
  {
    path: '', redirectTo: '/login', pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent, canActivate: [AuthGuard]
  },
  {
    path: 'forget-password', component: ForgetPasswordComponent, canActivate: [AuthGuard]
  },
  {
    path: 'home', loadChildren: () => import('./home/home.module').then((m: any) => m.HomeModule), canActivate: [AuthGuard]
  },
  { path: 'error', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
